import React from 'react';
import {
  Box,
  Container,
  Typography,
  Button,
  Grid,
  Card,
  CardContent,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import Header from '../components/Header/Header';
import './HomeView.css';
import Footer from '../components/Footer/Footer';

const HERO_VIDEO_SRC = `${import.meta.env.BASE_URL}video/cjp-sizzle.mp4`;


const HomeView = () => {
  const navigate = useNavigate();
  // const location = useLocation();
  const { user } = useAuth();
  


  const handleLoginClick = () => {
    if (user) {
      // User is authenticated, go to event selection
      navigate('/events');
    } else {
      // User is not authenticated, go to login
      navigate('/login');
    }
  };

  return (
    <div className='background-gradient'>
      <Header />
          {/* Hero Section */}
          <div className="hero-container">
            <video
              className="hero-video"
              src={HERO_VIDEO_SRC}
              autoPlay
              muted
              loop
              playsInline
              aria-hidden
            />
            <div className="hero-video-scrim" aria-hidden />
            <div className="hero-content">
              <div className="hero-title">studiogo</div>
              <div className="hero-tagline">beyond amazing</div>
              <Button
                variant="contained"
                size="large"
                onClick={handleLoginClick}
                className="hero-button"
              >
                Access Your Photos
              </Button>
            </div>
          </div>

          {/* Features Section */}
          <Box sx={{  margin:0, padding:6 }}>

          <Grid container spacing={4} sx={{ mb: 6 }}>
            <Grid item xs={12} md={4}>
              <Card sx={{ height: '100%', textAlign: 'center' }}>
                <CardContent sx={{ p: 4 }}>
                  <Typography variant="h4" component="h2" gutterBottom sx={{ color: '#db4481' }}>
                    📸
                  </Typography>
                  <Typography variant="h5" component="h3" gutterBottom>
                    Professional Quality
                  </Typography>
                  <Typography variant="body1" color="text.secondary">
                    High-resolution headshots captured by experienced photographers
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12} md={4}>
              <Card sx={{ height: '100%', textAlign: 'center' }}>
                <CardContent sx={{ p: 4 }}>
                  <Typography variant="h4" component="h2" gutterBottom sx={{ color: '#db4481' }}>
                    ⚡
                  </Typography>
                  <Typography variant="h5" component="h3" gutterBottom>
                    Quick Access
                  </Typography>
                  <Typography variant="body1" color="text.secondary">
                    View and download your photos instantly after your event
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12} md={4}>
              <Card sx={{ height: '100%', textAlign: 'center' }}>
                <CardContent sx={{ p: 4 }}>
                  <Typography variant="h4" component="h2" gutterBottom sx={{ color: '#db4481' }}>
                    📧
                  </Typography>
                  <Typography variant="h5" component="h3" gutterBottom>
                    Easy Sharing
                  </Typography>
                  <Typography variant="body1" color="text.secondary">
                    Share your favorite photos via email with friends and family
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
          </Box>
          

          {/* How It Works Section */}
          
          <Container maxWidth="lg" sx={{ mb: 10 }}>
            <Typography variant="h3" component="h2" gutterBottom sx={{ textAlign: 'center', mb: 4 }}>
              How It Works
            </Typography>
            <Grid container spacing={4} justifyContent="space-between" >
              <Grid item xs={12} md={2.8}>
                <Box sx={{ textAlign: 'center' }}>
                  <Typography variant="h2" sx={{ color: '#db4481', mb: 2 }}>1</Typography>
                  <Typography variant="h6" gutterBottom>Attend Your Event</Typography>
                  <Typography variant="body2" color="text.secondary">
                    Visit our headshot booth at your event
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={12} md={2.8}>
                <Box sx={{ textAlign: 'center' }}>
                  <Typography variant="h2" sx={{ color: '#db4481', mb: 2 }}>2</Typography>
                  <Typography variant="h6" gutterBottom>Get Your Photos</Typography>
                  <Typography variant="body2" color="text.secondary">
                    Professional photos are taken and processed
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={12} md={2.8}>
                <Box sx={{ textAlign: 'center' }}>
                  <Typography variant="h2" sx={{ color: '#db4481', mb: 2 }}>3</Typography>
                  <Typography variant="h6" gutterBottom>Login & Browse</Typography>
                  <Typography variant="body2" color="text.secondary">
                    Access your photos using your event credentials
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={12} md={2.8}>
                <Box sx={{ textAlign: 'center' }}>
                  <Typography variant="h2" sx={{ color: '#db4481', mb: 2 }}>4</Typography>
                  <Typography variant="h6" gutterBottom>Download & Share</Typography>
                  <Typography variant="body2" color="text.secondary">
                    Download your favorites and share with others
                  </Typography>
                </Box>
              </Grid>
            </Grid>
          </Container>
        <Footer />
    </div>
  );
};

export default HomeView; 